import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { SessionService } from '@ninety/platform/services';
import { CompanyUserListModel } from '@ninety/platform/state';
import {
  selectActiveCompanyUsers,
  selectCurrentCompanyUser,
} from '@ninety/platform/state/app-entities/company-users/company-users-state.selectors';
import { LogOutActions } from '@ninety/platform/state/app-global/auth/logout/logout.actions';
import { TerraIconModule } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';

@Component({
  selector: 'ninety-access-suspended',
  standalone: true,
  imports: [AsyncPipe, TerraIconModule, ButtonComponent],
  templateUrl: './access-suspended.component.html',
  styleUrls: ['./access-suspended.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessSuspendedComponent {
  private readonly store = inject(Store);
  private readonly sessionService = inject(SessionService);

  protected readonly otherCompanies$ = combineLatest([
    this.store.select(selectActiveCompanyUsers),
    this.store.select(selectCurrentCompanyUser),
  ]).pipe(map(([companies, current]) => companies.filter(company => company.companyId !== current?.companyId)));

  protected switchCompany(company: CompanyUserListModel): void {
    this.sessionService.switchCompany(company);
  }

  protected signOut(): void {
    this.store.dispatch(LogOutActions.initiateLogOut());
  }
}
